import { useContext } from 'react';
import { AnimationContext, AnimationHandlersContext } from '../AnimationContext';

export const useAnimationContext = () => {
    const context = useContext(AnimationContext);

    if (!context) {
        throw new Error('Please wrapp component in AnimateOnOpenProvider');
    }

    return context;
};

export const useAnimationHandlersContext = () => {
    const context = useContext(AnimationHandlersContext);

    if (!context) {
        throw new Error('Please wrapp component in AnimateOnOpenProvider');
    }

    return context;
};
